export function createBodyFlagRegistry(datasetKey, targetDocument = typeof document !== 'undefined' ? document : null) {
  const activeOwners = new Set();

  const sync = () => {
    if (!targetDocument?.body) return;
    if (activeOwners.size > 0) targetDocument.body.dataset[datasetKey] = 'true';
    else delete targetDocument.body.dataset[datasetKey];
  };

  return {
    setActive(owner, active) {
      if (!owner) return;
      if (active) activeOwners.add(owner);
      else activeOwners.delete(owner);
      sync();
    },
  };
}

export function createPlateControlRegistry(targetDocument = typeof document !== 'undefined' ? document : null) {
  return createBodyFlagRegistry('plateCalcActive', targetDocument);
}

export function createWorkoutSetEditingRegistry(targetDocument = typeof document !== 'undefined' ? document : null) {
  return createBodyFlagRegistry('workoutSetEditingActive', targetDocument);
}

export const WORKOUT_COACH_CLEARANCE_SETTLE_MS = 400;
export const plateControlRegistry = createPlateControlRegistry();
export const workoutSetEditingRegistry = createWorkoutSetEditingRegistry();
